import { LinkableEntityType } from '@api';
import { LinkableEntity } from '@common';
import { Avatar, Tooltip } from '@mantine/core';
import { getClaimerInitials } from './helpers';

type TaskClaimerAvatarPropsType = {
  claimedBy: LinkableEntityType | null;
};

export const TaskClaimerAvatar: React.FC<TaskClaimerAvatarPropsType> = ({
  claimedBy,
}) => {
  if (claimedBy === null) {
    return null;
  }

  const initials = getClaimerInitials(claimedBy.name);

  return (
    <LinkableEntity linkableEntity={claimedBy}>
      <Tooltip label={claimedBy.name}>
        <Avatar size={22} radius="xl" aria-label={claimedBy.name}>
          {initials}
        </Avatar>
      </Tooltip>
    </LinkableEntity>
  );
};
